$bog_bzrl_app $mol_page
	title @ \HomeRent
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_homerent_light
			theme_dark \$mol_theme_homerent_dark
			themes_default /string
				\$mol_theme_homerent_light
				\$mol_theme_homerent_dark
	head /
		<= Logo $mol_view
			sub /
				<= Logo_icon $mol_image
					uri \bog/bzrl/assets/favicon.png
				<= Logo_text $mol_view
					sub /
						<= logo_home \home
						<= l \ 
						<= logo_rent \rent
		<= Nav $bog_bzrl_app_nav
		<= Actions $mol_view
			sub /
				<= Profile $bog_bzrl_app_profile
					theme_auto <= Theme
	body /
		<= Rent_page? $bog_bzrl_app_rent
			attr *
				id \top
			district? <=> filter_district? \all
			rooms? <=> filter_rooms? \studio
			price_from? <=> filter_price? \
			search? <=> apartments_search? null
			apartments <= apartments_filtered /
			promo_action? <=> promo_action? null
		<= Let_page? $bog_bzrl_app_let
			action? <=> let_action? null
